import { cn } from "@/lib/cn";

type Variant = "default" | "success" | "warning" | "danger" | "info" | "purple";

export function Badge({ children, variant = "default" }: { children: React.ReactNode; variant?: Variant }) {
  const styles: Record<Variant, string> = {
    default: "bg-slate-100 text-slate-700",
    success: "bg-green-100 text-green-700",
    warning: "bg-amber-100 text-amber-700",
    danger: "bg-red-100 text-red-700",
    info: "bg-sky-100 text-sky-700",
    purple: "bg-purple-100 text-purple-700",
  };
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded text-xs font-medium", styles[variant])}>
      {children}
    </span>
  );
}
